import React from 'react';
import PropTypes from 'prop-types';
import ProductCollapseSkeleton from './productCollapseSkeleton';
import ProductDetailSkeleton from './productDetailSkeleton';
import ProductDetailMobileSkeleton from './productDetailMobileSkeleton';

const ProductContainerSkeleton = ({ ...props }) => {
  const { mobile } = props;
  return (
    <ProductCollapseSkeleton>
      {!mobile && <ProductDetailSkeleton />}
      {mobile && <ProductDetailMobileSkeleton />}
    </ProductCollapseSkeleton>
  );
};

ProductContainerSkeleton.propTypes = {
  mobile: PropTypes.bool,
};

export default ProductContainerSkeleton;
